import Box from 'components/elements/Box';
import React from 'react';
import RadioGroup from '../RadioGroup/RadioGroup';
import { ButtonContainer, Line, TopHeaderText } from './shared.styles';

export type TSwitcherPeriod = 'day' | 'week';
interface IPeriodSwitcherProps {
  rangeType: TSwitcherPeriod;
  setRangeType: (period: TSwitcherPeriod) => void;
}

interface IPeriodButton {
  label: string;
  value: TSwitcherPeriod;
}

const PeriodSwitcher: React.FC<IPeriodSwitcherProps> = (props) => {
  const { rangeType, setRangeType } = props;
  const buttonItems: IPeriodButton[] = [
    {
      label: 'Daily',
      value: 'day',
    },
    {
      label: 'Weekly',
      value: 'week',
    },
  ];

  return (
    <Box>
      <TopHeaderText>Display graph data:</TopHeaderText>
      <ButtonContainer>
        <RadioGroup
          options={buttonItems}
          name="date-picker-options"
          selectedOption={rangeType}
          onChange={(item: IPeriodButton): void => setRangeType(item.value)}
          isButtonNewDesigned
        />
      </ButtonContainer>
      <TopHeaderText>
        Maximum range is {rangeType === 'day' ? '30 days' : '52 weeks'}.
      </TopHeaderText>
      <Line />
    </Box>
  );
};

export default PeriodSwitcher;
